import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { type ReactNode } from "react";

import { ProgressBars } from "../../../components/ProgressBars";

interface SurveyStepLayoutProps {
  currentStep: number;
  totalSteps: number;
  title: string;
  subtitle?: string;
  onBack?: () => void;
  onContinue: () => void;
  continueDisabled?: boolean;
  continueLabel?: string;
  children: ReactNode;
}

export function SurveyStepLayout(props: SurveyStepLayoutProps) {
  const {
    currentStep,
    totalSteps,
    title,
    subtitle,
    onBack,
    onContinue,
    continueDisabled = false,
    continueLabel = "Continue",
    children,
  } = props;

  return (
    <Stack
      sx={(theme) => ({
        height: "100%",
        padding: 8,
        backgroundColor: theme.palette.background.tertiary,
      })}
      spacing={4}
    >
      <Stack spacing={1}>
        <Text variant="caption" sx={(theme) => ({ color: theme.palette.text.secondary })}>
          Step {currentStep + 1} of {totalSteps}
        </Text>
        <ProgressBars currentStep={currentStep} totalSteps={totalSteps} />
      </Stack>

      {onBack && (
        <Box>
          <IconButton
            iconType="arrow-left"
            size="small"
            sx={(theme) => ({
              border: 1,
              borderColor: theme.palette.border?.primary,
            })}
            variant={"contained"}
            onClick={onBack}
          />
        </Box>
      )}

      <Text semibold variant="h4">
        {title}
      </Text>

      {subtitle ? (
        <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
          {subtitle}
        </Text>
      ) : null}

      <Box sx={{ flex: 1, overflow: "auto", paddingY: 4 }}>{children}</Box>

      <Button
        fullWidth
        disabled={continueDisabled}
        variant="contained"
        sx={{ paddingY: 1.5 }}
        onClick={onContinue}
      >
        {continueLabel}
      </Button>
    </Stack>
  );
}
